// src/utils/dateFormatter.js

/**
 * Converts a UTC date string to local time and returns:
 * "1st Sep 25"
 */
export function formatToLocalDateFancy(utcString) {
  const date = new Date(utcString);

  const day = date.getDate();
  const month = date.toLocaleString(undefined, { month: "short" });
  const year = String(date.getFullYear()).slice(-2);

  const suffix =
    day % 10 === 1 && day !== 11 ? "st" :
    day % 10 === 2 && day !== 12 ? "nd" :
    day % 10 === 3 && day !== 13 ? "rd" : "th";

  return `${day}${suffix} ${month} ${year}`;
}

/**
 * Converts a UTC date string to local time and returns:
 * "1st Sep 25, 6:42 PM"
 */
export function formatToLocalDateTimeFancy(utcString) {
  const date = new Date(utcString);

  const fancyDate = formatToLocalDateFancy(utcString);
  const time = date.toLocaleString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });

  return `${fancyDate}, ${time}`;
}

export function formatToLocalTimeFancy(utcString) {
  const date = new Date(utcString);

  //const fancyDate = formatToLocalDateFancy(utcString);
  const time = date.toLocaleString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });

  return ` ${time}`;
}
